import { render } from "./InstallExtension.vue?vue&type=template&id=0905c877&scoped=true"
import script from "./InstallExtension.vue?vue&type=script&lang=js"
export * from "./InstallExtension.vue?vue&type=script&lang=js"

import "./InstallExtension.vue?vue&type=style&index=0&id=0905c877&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0905c877"]])

export default __exports__